import script from "./MostPlayedSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostPlayedSection.vue?vue&type=script&setup=true&lang=ts"

import "./MostPlayedSection.vue?vue&type=style&index=0&id=5b20c29c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b20c29c"]])

export default __exports__